// initial state
const state = {
  messages: [],
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const questionNotPassMessage = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/question-error-message/question-error-message.store.js